import React, { useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

interface SearchBarProps {
  onSearch: (query: string, location: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [query, setQuery] = useState('');
  const [location, setLocation] = useState('');
  const { t } = useTranslation();

  const trackSearch = (searchQuery: string, searchLocation: string) => {
    const payload = {
      query: searchQuery,
      location: searchLocation,
      url: window.location.href,
      timestamp: Date.now(),
    };
    const endpoint = 'https://api.escortfun.net/search-tracking/index.php';
    try {
      navigator.sendBeacon(endpoint, JSON.stringify(payload));
    } catch (_) {
      fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) }).catch(() => {});
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    trackSearch(query, location);
    onSearch(query, location);
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="flex flex-col md:flex-row gap-3 w-full max-w-4xl mx-auto"
    >
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder={t('searchBar.searchPlaceholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-300 focus:border-transparent text-black"
        />
      </div>
      <div className="relative md:w-1/3">
        <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder={t('searchBar.locationPlaceholder')}
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-pink-300 focus:border-transparent text-black"
        />
      </div>
      <button
        type="submit"
        className="py-3 px-6 bg-pink-500 hover:bg-pink-600 text-white rounded-lg transition-colors duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-pink-300 focus:ring-offset-2"
      >
        {t('searchBar.searchButton')}
      </button>
    </form>
  );
};

export default SearchBar;